import PropTypes from "prop-types";

export default function RecommendationText({ recommendedSizes, percentage }) {
  const [firstSize, secondSize] = recommendedSizes;

  return (
    <p>
      <span className="universal-small--secondary">{`Size ${firstSize}${
        secondSize ? ` or ${secondSize}` : ""
      } is a ${percentage}% match for you`}</span>
    </p>
  );
}

RecommendationText.propTypes = {
  recommendedSizes: PropTypes.arrayOf(PropTypes.string),
  percentage: PropTypes.number,
};
